import { create } from 'zustand';
import { api } from '../services/api';

export const useGroupSubscriptionsStore = create((set, get) => ({
  summary: null,
  isLoadingSummary: false,

  chartData: [],
  chartPeriod: '30days',
  isLoadingCharts: false,

  users: [],
  usersTotal: 0,
  usersPage: 1,
  usersLimit: 20,
  searchQuery: '',
  isLoadingUsers: false,
  error: null,

  fetchSummary: async () => {
    set({ isLoadingSummary: true, error: null });
    try {
      const data = await api.getGroupSubscriptionSummary();
      set({ summary: data, isLoadingSummary: false });
    } catch (error) {
      console.error('Failed to fetch group subscription summary:', error);
      set({ error: error.message, isLoadingSummary: false });
    }
  },

  fetchCharts: async (period = '30days') => {
    set({ isLoadingCharts: true, chartPeriod: period, error: null });
    try {
      const data = await api.getGroupSubscriptionCharts(period);
      set({ chartData: data, isLoadingCharts: false });
    } catch (error) {
      console.error('Failed to fetch group subscription charts:', error);
      set({ error: error.message, isLoadingCharts: false });
    }
  },

  fetchUsers: async (params = {}) => {
    const page = params.page || get().usersPage;
    const limit = params.limit || get().usersLimit;
    const search = params.search !== undefined ? params.search : get().searchQuery;

    set({ isLoadingUsers: true, usersPage: page, usersLimit: limit, searchQuery: search, error: null });
    try {
      const data = await api.getGroupSubscriptionUsers({ page, limit, search });
      set({
        users: data.items || [],
        usersTotal: data.total || 0,
        isLoadingUsers: false,
      });
    } catch (error) {
      console.error('Failed to fetch group subscription users:', error);
      set({ error: error.message, isLoadingUsers: false });
    }
  },
}));
